let initialState = {
	whInvoices: [],
};

const whInvoiceReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_WH_INVOICES':
			return {
				...state,
				whInvoices: action.payload,
			};
		default:
			return state;
	}
};

export { whInvoiceReducer };
